<div *transloco="let t; prefix: translationPrefix()">
  <p-dialog
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    header="{{ t('header') }}"
    [style]="{width: '650px'}"
    (onHide)="cancelSelection()"
  >
    @if (isLoading()) {
      <div class="flex justify-center">
        <i class="pi pi-spin pi-spinner text-2xl"></i>
      </div>
    } @else {
      @if (label()) {
        <h3 class="mb-6">{{ t('description.text') }} {{ label() }}</h3>
      }
      <h2 class="mb-2">{{ t('description.header') }}</h2>

      @if (hasSelectionLimit()) {
        <div class="mb-4 p-3 bg-third-level rounded-lg">
          <span class="font-semibold">{{ t('selectionLimit') }}: {{ selectionLimitText() }}</span>
        </div>
      }

      @if (showCrossModuleWarning()) {
        <div class="mb-4 p-3 bg-third-level rounded-lg">
          <i class="pi pi-info-circle mr-2"></i>
          <span>{{ t('singleModuleOnly') }}</span>
        </div>
      }
      @if (readOnly()) {
        <div class="mb-4 p-3 bg-third-level rounded-lg">
          <i class="pi pi-eye mr-2"></i>
          <span>{{ t('readOnlyMessage') }}</span>
        </div>
      }

      <div class="mt-4">
        @for (module of visibleModuleFunctionsEntries(); track module.key) {
          <div class="mb-4">
            <h4 class="font-medium mb-4">
              {{
                module.value.translations
                  | directusTranslation: activeLanguage() : 'Module ' + module.value.id
              }}
            </h4>

            <div class="ml-4 functions-grid">
              @for (moduleFunction of module.value.functions; track moduleFunction.id) {
                <div class="function-item">
                  <p-checkbox
                    [binary]="true"
                    [ngModel]="isSelected(moduleFunction)"
                    (ngModelChange)="toggleFunction(moduleFunction)"
                    [inputId]="'function_' + moduleFunction.id"
                    [attr.data-testid]="'function-' + moduleFunction.id"
                    [disabled]="isFunctionDisabled(moduleFunction)"
                  >
                  </p-checkbox>
                  <label [for]="'function_' + moduleFunction.id" class="ml-2">
                    {{
                      moduleFunction.translations
                        | directusTranslation: activeLanguage() : 'Function ' + moduleFunction.id
                    }}
                  </label>
                </div>
              } @empty {
                <div class="text-gray-500">
                  {{ t('noFunctionsForModule') }}
                </div>
              }
            </div>
          </div>
          <p-divider></p-divider>
        }

        @if (visibleModuleFunctionsEntries().length === 0) {
          <div class="text-center p-4">
            <p>{{ t('noFunctionsAvailable') }}</p>
          </div>
        }
      </div>
    }

    <div class="flex justify-end gap-2">
      <p-button
        label="{{ 'common.cancel' | transloco }}"
        severity="secondary"
        (onClick)="cancelSelection()"
        icon="pi pi-times"
        data-testid="cancel-button"
      />
      @if (!readOnly()) {
        <p-button
          label="{{ 'common.apply' | transloco }}"
          (onClick)="confirmSelection()"
          icon="pi pi-check"
          data-testid="apply-button"
          [disabled]="!canConfirmSelection()"
        />
      }
    </div>
  </p-dialog>
</div>
